module.exports = __webpack_public_path__ + "static/media/onethousandassists.ef0d2078.jpg";